import { useHeadingFocus } from 'platform/shared/health-apps';
import PropTypes from 'prop-types';
import React from 'react';
import {
  ENROLLMENT_STATUS_KEY,
  NOT_ENROLLED_STATUSES,
} from '../../utils/constants';
import { CONTACTS } from '../../utils/imports';

const ErrorAlert = () => (
  <va-alert status="error">
    <h1 slot="headline">We couldn’t complete your request</h1>
    <p>We’re sorry. Something’s not working right. Try again later.</p>
    <p>
      Or you can call us to learn about other ways you can update your CHAMPVA
      benefits. Call us at <va-telephone contact="8007338387" /> (
      <va-telephone contact={CONTACTS['711']} tty />
      ). We’re here Monday through Friday, 8:00 a.m. to 7:30 p.m.{' '}
      <abbr title="Eastern Time">ET</abbr>.
    </p>
  </va-alert>
);

const NotEnrolledAlert = () => (
  <va-alert status="warning">
    <h1 slot="headline">You can’t submit an update for CHAMPVA benefits</h1>
    <p>
      Our records show that you or the beneficiary aren’t enrolled in CHAMPVA.
    </p>
    <p>
      Only people who are currently enrolled in CHAMPVA can submit an update
      using this form.
    </p>
    <p>
      Keep reading to learn how to update an existing application or apply for
      CHAMPVA benefits.
    </p>
  </va-alert>
);

const EnrollmentCheckFailedPage = ({ data = {} }) => {
  const notEnrolled = NOT_ENROLLED_STATUSES.has(data[ENROLLMENT_STATUS_KEY]);

  useHeadingFocus('va-alert h1');

  return (
    <>
      <div className="vads-u-margin-bottom--4">
        {notEnrolled ? <NotEnrolledAlert /> : <ErrorAlert />}
      </div>

      <h2 className="vads-u-font-size--h3">
        Confirm we have information on file
      </h2>
      <p>
        We can only process updates for someone if they’re a beneficiary who’s
        currently enrolled in CHAMPVA.
      </p>

      <h3 className="vads-u-font-size--h4">
        If you are submitting information for yourself or someone else who is
        not currently enrolled in CHAMPVA
      </h3>
      <p>
        You’ll need to go back and select <strong>A new application</strong>.
        You must also submit a new application to reapply after a denial or loss
        of benefits.
      </p>

      <h3 className="vads-u-font-size--h4">
        If you recently applied and we asked you for more information
      </h3>
      <p>You have 3 ways to submit your missing information.</p>
      <p>
        <va-link
          href="/resources/what-to-do-after-applying-for-champva-benefits/"
          text="Learn how to submit your missing information"
        />
      </p>
    </>
  );
};

EnrollmentCheckFailedPage.propTypes = {
  data: PropTypes.object,
};

export default EnrollmentCheckFailedPage;
